<script>
import axios from "axios";

export default {
  name: "VersionCheck",
  emits: ["updateAvailable"],
  data() {
    return {
      hasUpdate: false,
      intervalId: 0
    };
  },
  props: {
    delay: {
      type: Number,
      default: 300000 // 5 minutes
      // 💡 -- TODO - This could be set in the config.
    }
  },
  methods: {
    compareVersions() {
      //console.log("Checking version...");

      axios
        .get("./index.html?ts=" + Date.now())
        .then((response) => response.data)
        .then((response) => {
          this.hasUpdate = false;
          const domParser = new DOMParser();
          const dom = domParser.parseFromString(response, "text/html");
          const meta = dom.querySelector("meta[name='version']");
          if (!meta) {
            console.error("Version tag not found");
            return;
          }
          const version = meta.getAttribute("content");
          //console.log("Current version:", this.version);
          //console.log("Latest version:", version);
          if (version !== this.$s("version")) {
            this.$emit("updateAvailable");
            this.hasUpdate = true;
          }
        });
    }
  },
  render() {
    return null;
  },
  mounted() {
    this.compareVersions();
    this.intervalId = setInterval(this.compareVersions, this.delay);
  },
  unmounted() {
    clearInterval(this.intervalId);
  }
};
</script>
